<template>
  <div class="talent-service-wrapper">
    <!-- 顶部60px白色区域 -->
    <div class="top-white-bar">
      <div class="title-container">
        <button @click="goHome" style="color: #646262;border: 1px solid #abaaaa;">网站首页</button>
      </div>
    </div>
    
    <div class="talent-service-container">
      <!-- 头部信息 -->
      <div class="header-section">
        <div class="container">
          <h1 class="service-title">数字化转型人才培养服务</h1>
          <p class="service-desc">通过数字化手段，将赋能人才、培养人才、服务人才有机结合，赋能企业，数字化转型赋能</p>
        </div>
      </div>

      <!-- 商品说明 -->
      <div class="section">
        <div class="container">
          <div class="section-title">
            <img class="mark-img" src="../assets/talentService/talentService_mark.png" alt="商品参数" />
            <div class="section-title-text">商品说明</div>
          </div>
          <div class="section-content">
            <div class="description-box">
              <div class="description-img">
                <img src="../assets/talentService/talentService_describe.png" alt="商品说明图" />
              </div>
              <div class="description-text">
                <p>依托华云及其合作伙伴在人才培养领域的深厚积淀，借助"教、学、练、测、评、证"的完整培养体系及华云天图AI平台的技术优势，打造人才培养增值服务。为高校、高职、企业和政府机关提供更优质的支持，展现产业人才培养全链路可视价值，成为产业数字化转型的强劲催化剂，助力客户稳步迈向智能化时代。</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 商品参数 -->
      <div class="section">
      <div class="container">
        <div class="section-title">
          <img src="../assets/talentService/talentService_mark_params.png" alt="商品参数" class="title-icon">
          <span class="section-title-text">商品参数</span>
        </div>
        <div class="parameter-grid">
          <div class="parameter-left">
            <div class="parameter-item">
              <div class="parameter-label">交付方式</div>
              <div class="parameter-value-box">
                <img class="parameter-value-icon" src="../assets/talentService/talentService_server.png" />
                <div class="parameter-value parameter-value-text">人工服务</div>
              </div>
            </div>
            <div class="parameter-item">
              <div class="parameter-label">交付期限</div>
              <div class="parameter-value-box">
                <img class="parameter-value-icon" src="../assets/talentService/talentService_term.png"  />
                <div class="parameter-value parameter-value-text">90个工作日</div>
              </div>
            </div>
          </div>
          <div class="parameter-right">
            <div class="parameter-item">
              <div class="parameter-label">服务对象</div>
              <div class="parameter-value-box">
                <img class="parameter-value-icon" src="../assets/talentService/talentService_object.png" />
                <div class="parameter-value-list">
                <span>1）高校、高职、中职学生及老师；</span>
                <span>2）企业、行业协会、非营利组织等行业从业人员；</span>
                <span>3）政府机构、事业单位等相关技术岗位；</span>
                <span>4）个人开发者、技术爱好者等；</span>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- 服务详情 -->
      <div class="section">
        <div class="container">
          <div class="section-title">
            <img class="mark-img" src="../assets/talentService/talentService_mark_detail.png" alt="商品参数" />
            <div class="section-title-text">服务详情</div>
          </div>
          <div class="service-detail-table">
            <img class="service-detail-img" src="../assets/talentService/talentService_product.jpg" alt="服务详情" />
          </div>
        </div>
      </div>

      <!-- 联系方式 -->
      <div class="section">
        <div class="container">
          <div class="section-title">
            <img src="../assets/talentService/talentService_mark_phone.png" alt="联系方式" class="title-icon">
            <span class="section-title-text">联系方式</span>
          </div>
          <div class="contact-section">
            <div class="contact-item">
              <div class="contact-icon">
                <img src="../assets/talentService/talentService_phone.png" alt="电话" />
              </div>
              <div class="contact-info">
                <span>PHONE</span>
                <div class="service-title">服务热线</div>
                <div class="phone-number">18319014743</div>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">
                <img src="../assets/talentService/talentService_time.png" alt="时间" />
              </div>
              <div class="contact-info">
                <span>TIME</span>
                <div class="service-title">服务时间</div>
                <div class="time-info">
                  <strong>周一至周五：8:00-21:00</strong>
                  <strong>周六至周日：10:00-18:00</strong>
                </div>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">
                <img src="../assets/talentService/talentService_email.png" alt="邮箱" />
              </div>
              <div class="contact-info">
                <span>EMAIL</span>
                <div class="service-title">服务邮箱</div>
                <div class="email-number">wangg@learningj.com</div>
              </div>
            </div>
            <div class="contact-item">
              <div class="contact-icon">
                <img src="../assets/talentService/talentService_content.png" alt="内容" />
              </div>
              <div class="contact-info">
                <span>CONTENT</span>
                <div class="service-title">服务内容</div>
                <div class="service-content">
                  <strong>售后：产品咨询、业务梳理、定制解决方案等</strong>
                  <strong>售前：问题咨询反馈及技术支持</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";

export default {
  name: 'TalentService',
  components: {
    Footer,
  },
  data() {
    return {};
  },
  mounted() {
    document.title = '数字化转型人才培养服务';
    // 添加CSS规则隐藏header
    this.addHeaderHideStyle();
  },
  beforeUnmount() {
    // 移除添加的样式，恢复header显示
    this.removeHeaderHideStyle();
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    addHeaderHideStyle() {
      // 创建一个样式标签并添加到head中
      const styleEl = document.createElement('style');
      styleEl.id = 'hide-header-style';
      styleEl.innerHTML = `
        #app > header {
          display: none !important;
        }
      `;
      document.head.appendChild(styleEl);
    },
    removeHeaderHideStyle() {
      // 移除样式标签
      const styleEl = document.getElementById('hide-header-style');
      if (styleEl) {
        document.head.removeChild(styleEl);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.talent-service-wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: #f4f5f7;
  padding-top: 0;
  position: relative;
  /* 顶部白色区域 */
.top-white-bar {
  width: 100%;
  height: 60px;
  background-color: #fff;
  position: relative;
  z-index: 1;
  .title-container{
      padding:15px;
  }
  }
}
.talent-service-container {
  width: 100%;
  min-height: calc(100vh - 60px);
  position: relative;
  z-index: 2;
  background-color: #f4f5f7;
}

.header-section {
  width: 100%;
  height: 124px;
  padding: 80px 0;
  background-image: url('../assets/talentService/talentService_bg.png');
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center top;
  color: #fff;
  position: relative;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.service-title {
  font-size: 38px;
  font-family: "PingFang SC";
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  width: 618px;
  height: 33px;
}

.service-desc {
  font-size: 15px;
  font-family: "PingFang SC";
  font-weight: 500;
  color: rgba(48, 49, 51, 1);
  width: 618px;
  margin-top: 12px;
  height: 28px;
}

.section {
  padding: 92px 0 30px 0;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  position: relative;
  margin-right: 170px;
}

.mark-img {
  width: 58px;
  height: 46px;
  margin-right: 7px;
}

.section-title h2 {
  font-size: 26px;
  font-family: "PingFang SC";
  font-weight: 500;
  color: rgba(48, 49, 51, 1);
  width: 108.08px;
  height: 36px;
  position: relative;
}

.section-title-text {
  font-size: 26px;
  font-family: "PingFang SC";
  font-weight: 500;
  color: rgba(48, 49, 51, 1);
  width: 108.08px;
  height: 36px;
}
.section-title h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 50px;
  height: 3px;
  background-color: #e74c3c;
}

.section-content {
  margin-top: 20px;
}

.contact-section {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 30px;
  margin-bottom: 34px;
}

.contact-item {
  width: 20%;
  display: flex;
  align-items: flex-start;
  padding: 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  flex-direction: column;
  position: relative;
}

.contact-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
}

.contact-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  margin-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-icon img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.contact-info {
  width: 100%;
  position: relative;
}

.contact-info::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 52px;
  height: 1px;
  border-bottom: 1px dashed #e0e0e0;
}

.contact-info span {
  font-size: 14px;
font-family: "PingFang SC";
font-weight: 400;
color: rgba(96, 98, 102, 1);
margin-bottom: 5px;
}

.contact-info .service-title {
 font-size: 14px;
font-family: "PingFang SC";
font-weight: 500;
color: rgba(96, 98, 102, 1);
}

.phone-number, .email-number {
  display: block;
  font-size: 14px;
  font-family: "PingFang SC";
  font-weight: 600;
  color: rgba(48, 49, 51, 1);
  margin-bottom: 5px;
  margin-top: 10px;
}
.contact-info strong {
  display: block;
  font-size: 14px;
  font-family: "PingFang SC";
  font-weight: 600;
  color: rgba(48, 49, 51, 1);
  margin-bottom: 5px;
  margin-top: 10px;
}
.contact-info strong:last-child {
  display: block;
  font-size: 14px;
  font-family: "PingFang SC";
  font-weight: 600;
  color: rgba(48, 49, 51, 1);
  margin-bottom: 5px;
  margin-top: 0px;
}

.time-info {
  display: flex;
  flex-direction: column;
}

.service-content {
  margin-top: 10px;
}

.service-content strong {
  display: block;
  margin-bottom: 8px;
  line-height: 1.5;
  font-size: 14px;
}

@media (max-width: 1200px) {
  .container {
    width: 100%;
    padding: 0 20px;
  }
  
  .description-box {
    flex-direction: column;
  }
  
  .description-img, .description-text {
    width: 100%;
  }
  
  .parameter-grid {
    grid-template-columns: 1fr;
  }
  
  .service-target {
    grid-column: span 1;
  }
  
  .contact-item {
    width: 48%;
    margin-bottom: 20px;
  }
  
  
}

.service-detail-table {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .service-detail-img {
      width: 100%;
    }
    
@media (max-width: 768px) {
  .contact-item {
    width: 100%;
  }
  
  .service-title {
    width: 100%;
  }
  
  .service-desc {
    width: 100%;
  }
}

.description-box {
  display: flex;
  justify-content: center;
  width: 100%;
}



.description-img img {
  width: 100%;
}

.description-text {
  flex: 1;
  background-color: #fff;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-bottom: 4px;
}

.description-text p {
  font-size: 16px;
  font-family: "PingFang SC";
  font-weight: 400;
  color: rgba(48, 49, 51, 1);
  padding: 10px 24px 20px 24px;
  line-height: 30px;
}

.parameter-grid {
  display: flex;
  width: 100%;
  border-radius: 4px;
  margin-top: 20px;
  overflow: hidden;
  align-items: center;
}

.parameter-left {
  display: flex;
  flex-direction: column;
}

.parameter-item {
  display: flex;
  padding: 15px 20px;
  align-items: center;
  justify-content: center;
}

.parameter-item:last-child {
  border-bottom: none;
}

.parameter-value-box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding:8px;
  background-color: #fff;
  border-radius: 6px;
}

.parameter-value-icon {
  width: 94%;
  position: absolute;
  left: 13px;
  top: 11px;
}

.parameter-label {
  font-size: 20px;
  font-family: "PingFang SC";
  font-weight: 600;
  color: rgba(27, 71, 191, 1);
  width: 80px;
  height: 28px;
  margin-right: 22px;
  flex-shrink: 0;
}
.parameter-value-text {
  padding: 16px 0 10px 20px;
}

.parameter-value {
  font-size: 18px;
  font-family: "PingFang SC";
  font-weight: 500;
  color: rgba(48, 49, 51, 1);
  flex: 1;
  border-radius: 6px;
  background-color: #fff;
  width: 360px;
}
.parameter-right .parameter-item {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-bottom: none;
}

.parameter-right .parameter-item .parameter-label {
  margin-top: 20px;
}

.parameter-right .parameter-value-list {
  padding: 0;
  margin: 0;
  background-color: #fff;
  padding: 12px 0 20px 43px;
  width: 488px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  line-height: 30px;
  justify-content: center;
}

.parameter-right .parameter-value-list p {
  font-size: 16px;
  font-family: "PingFang SC";
  font-weight: 500;
  color: rgba(48, 49, 51, 1);
  position: relative;
  padding-left: 0;
  margin-bottom: 5px;
  line-height: 1.8;
}
</style> 